import { TABLET_VERSION_BREAKPOINT } from '../../../../../utils/styles/helpers';

export const MODAL_BREAKPOINT = TABLET_VERSION_BREAKPOINT;
